import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core, Decorative } from "@faire/design-tokens";
import { FooterSEOContent } from "@faire/retailer-visitor-shared/components/Footer/FooterSEOContent";
import { TestimonialsCardSection } from "@faire/retailer-visitor-shared/components/TestimonialsCardSection/TestimonialsCardSection";
import { useTopOfPageContent } from "@faire/retailer-visitor-shared/stores/ui/useTopOfPageContent";
import { getJobOpeningCount } from "@faire/retailer-visitor-shared/views/careers/__internal__/common/common";
import { useDepartments } from "@faire/retailer-visitor-shared/views/careers/__internal__/common/useDepartments";
import { CareersFooterImage, CareersHeroImage } from "@faire/retailer-visitor-shared/views/careers/__internal__/components/FullWidthImages";
import { JobOpeningsSection } from "@faire/retailer-visitor-shared/views/careers/__internal__/components/JobOpeningsSection";
import { FAIRE_EMPLOYEES } from "@faire/retailer-visitor-shared/views/careers/__internal__/LifeatFaire/faireEmployees";
import { LandingPageHeroSection } from "@faire/retailer-visitor-shared/views/careers/__internal__/LifeatFaire/LandingPageHeroSection";
import { OurBenefitsImagesSection } from "@faire/retailer-visitor-shared/views/careers/__internal__/LifeatFaire/OurBenefitsImagesSection";
import { OurBenefitsSection } from "@faire/retailer-visitor-shared/views/careers/__internal__/LifeatFaire/OurBenefitsSection";
import { OurValuesSection } from "@faire/retailer-visitor-shared/views/careers/__internal__/LifeatFaire/OurValuesSection";
import { ValuePropositionSection } from "@faire/retailer-visitor-shared/views/careers/__internal__/LifeatFaire/ValuePropositionSection";
import { delay } from "@faire/web--source/common/delay";
import { getLocation } from "@faire/web--source/common/globals/getLocation";
import { getWindow } from "@faire/web--source/common/globals/getWindow";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Column } from "@faire/web--source/slate/Layout";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React, { useEffect, useRef } from "react";
export var CareersLandingPage = function() {
    var strictLocalize = useStrictLocalization().strictLocalize;
    var _useDepartments_EMPLOYMENT = useDepartments(strictLocalize).EMPLOYMENT, departments = _useDepartments_EMPLOYMENT.departments, isLoading = _useDepartments_EMPLOYMENT.isLoading;
    var headerPlusPromoBannerHeight = useTopOfPageContent().headerPlusPromoBannerHeight;
    var rootRef = useRef(null);
    var jobCount = getJobOpeningCount(departments);
    useEffect(function() {
        var _getLocation;
        var hash = ((_getLocation = getLocation()) !== null && _getLocation !== void 0 ? _getLocation : {}).hash;
        if (hash) {
            var _rootRef_current;
            var element = (_rootRef_current = rootRef.current) === null || _rootRef_current === void 0 ? void 0 : _rootRef_current.querySelector(hash);
            if (element) {
                delay(500).then(function() {
                    var _getWindow, _getWindow_scrollTo, _getWindow1;
                    var _getWindow_pageYOffset;
                    var yCoordinate = element.getBoundingClientRect().top + ((_getWindow_pageYOffset = (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.pageYOffset) !== null && _getWindow_pageYOffset !== void 0 ? _getWindow_pageYOffset : 0);
                    (_getWindow1 = getWindow()) === null || _getWindow1 === void 0 ? void 0 : (_getWindow_scrollTo = _getWindow1.scrollTo) === null || _getWindow_scrollTo === void 0 ? void 0 : _getWindow_scrollTo.call(_getWindow1, {
                        top: yCoordinate - headerPlusPromoBannerHeight,
                        behavior: "smooth"
                    });
                });
            }
        }
    }, [
        headerPlusPromoBannerHeight,
        rootRef
    ]);
    return /*#__PURE__*/ _jsxs(Column, {
        ref: rootRef,
        children: [
            /*#__PURE__*/ _jsx(LandingPageHeroSection, {
                openingsCount: jobCount,
                isLoading: isLoading
            }),
            /*#__PURE__*/ _jsx(ValuePropositionSection, {}),
            /*#__PURE__*/ _jsx(CareersHeroImage, {}),
            /*#__PURE__*/ _jsx(OurValuesSection, {}),
            /*#__PURE__*/ _jsx(TestimonialsCardSection, {
                testimonials: FAIRE_EMPLOYEES(strictLocalize),
                title: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "6mWdAq",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Employee Voices"
                        }
                    ]
                }),
                titleColor: Core.text.subdued,
                backgroundColor: Decorative.tint.neutral,
                textColor: Core.text.default
            }),
            /*#__PURE__*/ _jsx(OurBenefitsImagesSection, {}),
            /*#__PURE__*/ _jsx(OurBenefitsSection, {}),
            /*#__PURE__*/ _jsx(JobOpeningsSection, {}),
            /*#__PURE__*/ _jsx(CareersFooterImage, {}),
            /*#__PURE__*/ _jsx(FooterSEOContent, {})
        ]
    });
};
